import { h } from '@stencil/core';
import { QdsSize, productCtasButtonType, comparator } from '@pes-ui/utils';
export class CompareControl {
  constructor() {
    this.onChange = (e) => {
      this.comparatorClick.emit(this.productId);
      this.ctaClick.emit({
        type: productCtasButtonType.COMPARE,
        initialEvent: e,
        product: {
          id: this.productId,
        },
      });
    };
    this.productId = undefined;
    this.label = undefined;
    this.selected = this.isSelected();
    this.disabled = this.isDisabled();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  isSelected() {
    return comparator.has(this.productId);
  }
  isDisabled() {
    return comparator.isFull() && !this.selected;
  }
  updateState() {
    if (this.selected === this.isSelected() && this.disabled === this.isDisabled()) {
      return;
    }
    this.selected = this.isSelected();
    this.disabled = this.isDisabled();
  }
  watchProductIdHandler() {
    this.updateState();
  }
  handleComparatorChange() {
    this.updateState();
  }
  render() {
    return (h("qds-checkbox", { class: "compare-control", text: this.label, size: QdsSize.SMALL, checked: this.selected, disabled: this.disabled, onQdsChange: this.onChange }));
  }
  static get is() { return "pes-compare-control"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["compare-control.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["compare-control.css"]
    };
  }
  static get properties() {
    return {
      "productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "ID of the product to add to the Comparator"
        },
        "attribute": "product-id",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "A label to show next to the checkbox"
        },
        "attribute": "label",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "selected": {},
      "disabled": {}
    };
  }
  static get events() {
    return [{
        "method": "comparatorClick",
        "name": "comparatorClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event with ID of the product added to the Comparator"
        },
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "ctaClick",
        "name": "ctaClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Event that contains info about what CTA button was clicked"
        },
        "complexType": {
          "original": "TCtaClick",
          "resolved": "{ id?: string; type: string; initialEvent: MouseEvent; product: TMyProductsAddParams; inList?: boolean; onFinish?: (result?: TMyProductsAddResponse | TMyProductsRemoveResponse) => any; bannerContext?: \"body\" | \"header\"; }",
          "references": {
            "TCtaClick": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "productId",
        "methodName": "watchProductIdHandler"
      }];
  }
  static get listeners() {
    return [{
        "name": "comparatorProductsChange",
        "method": "handleComparatorChange",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
